module.exports = __webpack_public_path__ + "static/media/Energie.e1bd04f5.svg";